import type { Person } from '../../../eventsApi/persons/person'

export class PartnerPerson {
    partnersPersonsId: string
    companyId: string
    personId: string
    partnerId: string
    createdAt: Date
    updatedAt: Date
    status: number
    startAt: Date
    person?: Person
}
